module.exports = __webpack_public_path__ + "img/img_live cell-1.d5321be9.png";